export class ImportError {
    id: string;
    code: string;
    objectId: string;
    message: string;
    resolution: string;
    createdOn: string;
    clientId: number;
    clientName: string;
    locationId: number;
    locationName: string;
    mealId: number;
    date: Date;
}
